import axios from 'axios';
import { Message } from 'element-ui';
import QS from 'qs';
import { isLoading } from '@/common/loading';

axios.defaults.baseURL = process.env.VUE_APP_HTTP;
axios.defaults.timeout = 100000;
axios.defaults.headers.post['Content-Type'] =
    'application/x-www-form-urlencoded;charset=UTF-8';
axios.interceptors.request.use(
    (config) => {
        return config;
    },
    (error) => {
        return Promise.error(error);
    }
);
axios.interceptors.response.use(
    (response) => {
        let code = response.data.code;
        // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
        // 否则的话抛出错误
        if (response.status === 200) {
            if (code == '20000') {
                return Promise.resolve(response);
            } else {
                isLoading(0);
                Message({
                    message: response.data.message,
                    type: 'error',
                });
                return Promise.reject(response);
            }
        } else {
            isLoading(0);
            Message({
                message: response.data.message,
                type: 'error',
            });
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是2开头的的情况
    // 这里可以跟你们的后台开发人员协商好统一的错误状态码
    // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
    // 下面列举几个常见的操作，其他需求可自行扩展
    (error) => {
        isLoading(0);
        if (error.response.status) {
            switch (error.response.status) {
                // 401: 未登录
                // 未登录则跳转登录页面，并携带当前页面的路径
                // 在登录成功后返回当前页面，这一步需要在登录页操作。
                case 401:
                    break;

                // 403 token过期
                // 登录过期对用户进行提示
                // 清除本地token和清空vuex中token对象
                // 跳转登录页面
                case 403:
                    break;

                // 404请求不存在
                case 404:
                    // Toast({
                    //     message: '网络请求不存在',
                    //     duration: 1500,
                    //     forbidClick: true
                    // });
                    break;
                // 其他错误，直接抛出错误提示
                // default:
                //     Toast({
                //         message: error.response.data.message,
                //         duration: 1500,
                //         forbidClick: true
                //     });
            }
            return Promise.reject(error.response);
        }
    }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .get(url, {
                params: params,
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
                throw err;
            });
    });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, QS.stringify(params))
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}

/**
 * json Post
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function postJson(url, params) {
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
            });
    });
}

/**
 * 下载方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function postDownFile(method, url, params) {
    return new Promise((resolve, reject) => {
        axios({
            method,
            url,
            params,
            responseType: 'blob',
        })
            .then((res) => {
                var reader = new FileReader();
                reader.readAsText(res.data);
                reader.onload = (e) => {
                    try {
                        //判断接口是否返回失败信息
                        if (JSON.parse(e.target.result).success == false) {
                            // Modal.error({
                            //     title: '错误信息',
                            //     okText: '确定',
                            //     content: JSON.parse(e.target.result).msg,
                            //     centered: true,
                            // });
                        }
                        return Promise.reject(res);
                    } catch (e) {
                        resolve(res.data);
                    }
                };
            })
            .catch((err) => {
                reject(err.data);
                throw err;
            });
    });
}

/**
 * 上传文件方法
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */

export function uploadFile(url, params) {
    // params = QS.stringify(params, { arrayFormat: 'brackets' })
    return new Promise((resolve, reject) => {
        axios
            .post(url, params, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            })
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err.data);
                throw err;
            });
    });
}
